import { type FC } from "react";

import { cn } from "@/shared/lib/utils";

interface SelectableChipProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
}

export const SelectableChip: FC<SelectableChipProps> = ({
  label,
  selected,
  onClick,
  className,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "rounded-full border px-3 py-2 text-sm transition-colors",
        selected
          ? "border-brand bg-brand-subtle font-medium text-brand"
          : "border-primary bg-white text-primary",
        className,
      )}
    >
      {label}
    </button>
  );
};
